import { z } from "zod";
import { AdjustmentReason } from "../enums";

/**
 * Validation schema for a manual point adjustment. Requires a non-zero delta
 * and mandatory internal notes so every adjustment is auditable.
 */
export const pointAdjustmentSchema = z
  .object({
    memberId: z.string().min(1, { message: "member_required" }),
    points: z
      .number()
      .int({ message: "points_must_be_integer" })
      .refine((v) => v !== 0, { message: "points_must_be_nonzero" }),
    qualifyingPoints: z.number().int().optional(),
    reason: z.enum(AdjustmentReason),
    internalNotes: z
      .string()
      .trim()
      .min(5, { message: "adjustment_notes_required" })
      .max(500, { message: "max_characters_error" }),
    externalReference: z.string().trim().max(120, { message: "max_characters_error" }).optional(),
  })
  .refine(
    (data) => data.reason !== AdjustmentReason.OTHER || data.internalNotes.length >= 10,
    { message: "adjustment_notes_detail_required", path: ["internalNotes"] },
  );

export type PointAdjustmentFormValues = z.infer<typeof pointAdjustmentSchema>;
